import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportInterventionTimeWidgetComponent } from './transport-intervention-time-widget.component';
import {DxChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [TransportInterventionTimeWidgetComponent],
    imports: [
        CommonModule,
        DxChartModule
    ],
  exports: [TransportInterventionTimeWidgetComponent]
})
export class TransportInterventionTimeWidgetModule { }
